<template>
  <v-card
    color="deep-purple"
    class="fill-height mb-12 pb-12"
    dark
  >
    <v-card-title>
      <h1
        class="headline"
      >
        Usein kysytyt kysymykset
      </h1>
    </v-card-title>
    <v-card-text>
      <p>
        Olemme saaneet paljon palautetta ja kysymyksiä, joita olemme
        koonneet yhteen läpinäkyvyyden ja kommunikaation parantamiseksi.
      </p>

      <p>
        Toivomme edelleen palautetta, korjausehdotuksia ja vinkkejä Vilkkeen kehittämiseksi :)
      </p>

      <v-expansion-panels>
        <v-expansion-panel
          v-for="(item, i) in items"
          :key="i"
          light
          focusable
        >
          <v-expansion-panel-header>
            {{ item.q }}
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <p
              v-html="item.a"
              class="mb-0"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  computed: {
    items() {
      return [
        {
          q: 'Yhteydenottokyselyt',
          a: 'Yhteydenottokyselyt häiritsevät monia.<br><br>Vilke on anonyymi sovellus luoda ja jakaa tuhmaa sisältöä, mutta sen pääasiallinen tarkoitus ei ole toimia deittipalstana.'
            + ' Tämän vuoksi vain julkaisujen aloittajilla on oikeus kysellä yhteydenottoja. Huomioithan tämän kommentoidessasi kuvia.',
        },
        {
          q: 'Miksi sivusto pyytää lupaa paikannukseen?',
          a: 'Vilke perustuu paikalliseen sisältöön, ja paikallisen sisällön näyttäminen on mahdollista ainoastaan käyttämällä'
            + ' laitteen sijaintia. Millään sivustolla ei ole lähtökohtaisesti lupaa paikannuksen käyttöön, mistä syystä'
            + ' pyydämmekin paikannukseen lupaa Sinulta.',
        },
        {
          q: 'Mitä poistamilleni kuville tapahtuu?',
          a: 'Poistamasi kuvat tuhotaan tietokannasta välittömästi. On kuitenkin hyvä muistaa, että'
            + ' nettiin ladattua kuvaa ei välttämättä ole mahdollista saada koskaan pois.'
            + ' Lisääthän siis vain sellaisia kuvia, joihin olet itse tyytyväinen.',
        },
        {
          q: 'Miksi nettisivu eikä sovellus?',
          a: 'Sovelluskaupat eivät julkaise sovelluksia, joihin liittyy alastomuutta. Sivuston tavoitteena on kuitenkin olla sovelluksenomainen.'
            + ' Sovellusmaisuutta tukee erityisesti se, että käyttäjä voi lisätä pikakuvakkeen puhelimensa kotinäytölle. Pikakuvakkeen kautta selain aukeaa ns.'
            + ' sovellustilassa, jossa muun muassa selaimen osoitepalkki jää piiloon. Pikakuvake helpottaa myös sivustolle palaamista.',
        },
        {
          q: 'Mikä ihmeen pikakuvake?',
          a: 'Nykyaikaiset selaimet tukevat pikakuvakkeen lisäämistä kotinäytölle. Pikakuvakkeen kautta käyttäjä saa täyden hyödyn sivuston ominaisuuksista, ja sivustosta'
            + ' tulee entistäkin sovelluksenomaisempi. Sovellusmaisia ominaisuuksia ovat muun muassa sivuston nopea avautuminen, piilotettu osoitepalkki,'
            + ' ja push-ilmoitukset.',
        },
        {
          q: 'Päivitykset',
          a: 'Olet mahdollisesti huomannut, että sivustolla on ajoittain uusia päivityksiä saatavilla. Sovelluksenomaisesta luonteesta johtuen sivuston ohjelmakoodia päivitetään'
            + ' pyytämällä käyttäjää lataamaan sivusto uudelleen.',
        },
        {
          q: 'Ilmoitukset',
          a: 'Ilmoitukset ovat puhelinsovelluksista tuttuja push-ilmoituksia, joiden tavoitteena on kertoa Sinulle uusista kommenteista tai tykkäyksistä. Voit ottaa ilmoitukset päälle'
            + ' Profiili-välilehdeltä, ja ne toimivat ainoastaan Chrome ja Firefox -selaimilla. Safari-selain ei toistaiseksi tue push-ilmoituksia.',
        },
        {
          q: 'Etäisyysasteikko',
          a: 'Vilkkeessä on käytössä Jodelista tuttu etäisyysasteikko, jonka tavoitteena on viestiä julkaisujen etäisyyksiä suhteessa nykyiseen sijaintiisi.'
            + '<br><br>'
            + '<b>Täällä</b>'
            + '<br>'
            + 'Alle kilometrin säteellä'
            + '<br><br>'
            + '<b>Lähellä</b>'
            + '<br>'
            + 'Suurimmillaan kolmen kilometrin säteellä'
            + '<br><br>'
            + '<b>Alueella</b>'
            + '<br>'
            + 'Suurimmillaan yhdentoista kilometrin säteellä',
        },
        {
          q: 'Asiattomat julkaisut',
          a: 'Vilkkeessä on käytössä nollatoleranssi asiattomille julkaisuille. Käyttäjän tili lukitaan varoituksetta, mikäli julkaisut sisältävät laittomuuksia tai asiattomuuksia.'
            + ' Näitä ovat esimerkiksi vihapuhe, loukkaavat tai rasistiset kommentit, tai luvatta julkaistut kuvat.'
            + '<br><br>'
            + 'Lukituksen mukana tallennetaan käyttäjän IP-osoite ja laitetietoja, jotka ohjataan tarvittaessa viranomaisille.'
            + '<br><br>'
            + 'Maalaisjärjen käyttö on sallittua.',
        },
        {
          q: 'Perusteettomat ilmiannot',
          a: 'Käyttäjän tili lukitaan varoituksetta, mikäli ilmiantoja tehdään perusteettomasti.'
            + '<br><br>'
            + 'Maalaisjärjen käyttö on sallittua.',
        },
        {
          q: 'Miksi minut on hiljennetty?',
          a: 'Oletko rikkonut sääntöjä? Käyttäjä voidaan hiljentää määrätyksi ajaksi varoituksena sääntörikkomuksista.'
            + '<br><br>'
            + 'Maalaisjärjen käyttö on sallittua.',
        },
      ];
    },
  },
};
</script>
